// @ts-nocheck
import React, { Fragment, lazy } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import yn from 'yn'

import Auth from 'Auth'
import Zendesk from 'Auth/Zendesk'
import { ShellRoute } from 'App/Shell'
import FourOFour from 'App/FourOFour'
import Checkout from 'Checkout'
import HomeRouter from 'HomePage/HomeRouter'

import { ProductCategory } from 'features/ProductCategory'
import { Store, StoreVoucher } from 'features/Store'
import { Modal } from 'loyal-react'
import { ConfirmationCreditMileage } from 'features/Services/ConfirmationCreditMileage'
import { MyOrders, ProductOrderDetail } from 'Participant/MyOrders'
import { Confirmation } from 'features/Confirmation'
import {
  AddressPage,
  ProfilePage,
  ExtractPage,
  ChangePassword,
  SecurityAccessPage,
  ChangeUraPasswordPage,
  TwoStepVerificationPage,
  FaqTwoStep
} from 'Participant'
import { Scheduling } from 'Participant/Scheduling'

import { WishlistPage } from 'Participant/Wishlist'

import { ConfirmationDonation } from 'features/ConfirmationDonation'
import { Cellphonerecharge } from 'features/CellphoneRecharge'
import { BillPaymentContainer } from 'features/BillPayment'
import { MileageContainer } from 'features/MileageRescue'
import InvoiceCredit from 'features/InvoiceCredit'

import { FuelCreditContainer } from 'features/FuelCredit'
import { DonationContainer } from 'features/Donation'
import { PointsAndCash } from 'features/PointsAndCash'
import { CartContainer } from 'features/Cart'
import { ConfirmationMobileRechargeSchedule } from 'features/ConfirmationMobileRechargeSchedule'
import { SearchPage, SearchVendor, ShowCase } from 'Catalog/Search'

import Benefits from 'features/Benefits'
import RedirectCustom from 'features/RedirectCustom/RedirectCustom'
import { UnlockUraPasswordPage } from 'Participant/UraPassword/UnlockUraPassword'
import AccessibilityStatus from 'features/Accessibility/AccessibilityStatus'
import { CreateUraPasswordPage } from 'Participant/UraPassword/CreateUraPassword'

import Maintenance from 'features/Maintenance/Maintenance'
import LikePlus from 'features/LikePlus/Container'
import { LandingCashback } from 'features/LandingPage/LandingCashback'
import { LandingCashbackBlack } from 'features/LandingPage/LandingCashbackBlack'
import { LandingCashbackDms } from 'features/LandingPage/LandingCashbackDms'
import { StixContainer } from 'features/Stix'

const Terms = lazy(() => import('features/Terms/Terms'))
const RegulationPage = lazy(() => import('features/Regulation/RegulationPage'))
const CookiesRegulationPage = lazy(() => import('features/Regulation/CookiesRegulationPage'))
const Privacy = lazy(() => import('features/Privacy/Privacy'))
const Security = lazy(() => import('features/Security/Security'))
const OffersListing = lazy(() =>
  import('features/OffersClub/Listing/OffersListing')
)

const ProductDetailColumn = lazy(() => import('Catalog/Product/ProductDetailColumn/ProductDetailPageContainer'))
const ProductDetail = lazy(() => import('Catalog/Product/ProductDetail/ProductDetailPageContainer'))

const AppRouter = () => (
  <Fragment>
    {yn(process.env.REACT_APP_ISMAINTENANCE) ? (
      <Switch>
        <Route path='/' exact component={Maintenance} />
        <ShellRoute component={Maintenance} isGuest />
      </Switch>
    ) : (
      <Switch>
        <Route path='/zendesk' component={Zendesk} />
        <Route path='/auth' component={Auth} />
        <Route path='/' exact component={HomeRouter} />
        <ShellRoute path='/invoice-credit' component={InvoiceCredit} />
        <ShellRoute path='/like-mais' component={LikePlus} />
        <ShellRoute path='/like-plus' component={LikePlus} />
        <ShellRoute path='/checkout' component={Checkout} />
        <ShellRoute path='/products/:sku' component={yn(process.env.REACT_APP_PRODUCTPAGE_COLUMN) ? ProductDetailColumn : ProductDetail} />
        <ShellRoute path='/categories' component={ProductCategory} />
        <ShellRoute
          path='/services/confirmation/:orderId'
          component={ConfirmationCreditMileage}
        />
        <ShellRoute path='/stores/vouchers' component={StoreVoucher} />
        <ShellRoute path='/stores' component={Store} />
        <ShellRoute path='/my-orders' component={MyOrders} />
        <ShellRoute
          path='/order/:parentOrderId/:orderId/product/:productId'
          component={ProductOrderDetail}
        />

        <ShellRoute path='/confirmation/:orderId' component={Confirmation} />
        <ShellRoute
          path='/two-step-verification'
          component={TwoStepVerificationPage}
        />
        <ShellRoute path='/faq-two-step' component={FaqTwoStep} />
        <ShellRoute path='/modal' component={Modal} />
        <ShellRoute path='/scheduling' component={Scheduling} />
        <ShellRoute
          path='/my-account/change-password'
          component={ChangePassword}
        />
        <ShellRoute path='/security-access' component={SecurityAccessPage} />
        <ShellRoute
          path='/change-ura-password'
          component={ChangeUraPasswordPage}
        />
        <ShellRoute
          path='/unlock-ura-password'
          component={UnlockUraPasswordPage}
        />
        <ShellRoute
          path='/create-ura-password'
          component={CreateUraPasswordPage}
        />
        <ShellRoute path='/wishlist' component={WishlistPage} />
        <ShellRoute path='/my-address' component={AddressPage} />
        <ShellRoute path='/extract' component={ExtractPage} />
        <ShellRoute path='/profile' component={ProfilePage} />
        <ShellRoute path='/mobile-recharge' component={Cellphonerecharge} />
        <ShellRoute
          path='/confirmation-donation'
          component={ConfirmationDonation}
        />
        <ShellRoute path='/pointsandcash' component={PointsAndCash} />
        <ShellRoute path='/billpayment' component={BillPaymentContainer} />
        <ShellRoute path='/fuelcredit' component={FuelCreditContainer} />
        <ShellRoute path='/donation' component={DonationContainer} />

        <ShellRoute path='/mileage' component={MileageContainer} />
        <ShellRoute path='/showcase' component={ShowCase} />
        <ShellRoute path='/search' component={SearchPage} />
        <ShellRoute path='/vendor' component={SearchVendor} />
        <ShellRoute
          path='/mobile-recharge/confirmation/:scheduleId'
          component={ConfirmationMobileRechargeSchedule}
        />
        <ShellRoute path='/cart' component={CartContainer} />
        <ShellRoute path='/terms' component={Terms} isGuest />
        <ShellRoute path='/regulation' component={RegulationPage} isGuest />
        <ShellRoute path='/cookies-regulation' component={CookiesRegulationPage} isGuest />

        <ShellRoute path='/privacy' component={Privacy} isGuest />
        <ShellRoute path='/security' component={Security} isGuest />
        <ShellRoute
          path='/accessibility-status'
          component={AccessibilityStatus}
          isGuest
        />

        <ShellRoute path='/benefits' component={Benefits} />

        {process.env.REACT_APP_LADDING_CASHBACK &&
          <ShellRoute
            path='/cashback-funcionario'
            component={LandingCashback}
          />
        }

        {process.env.REACT_APP_LADDING_CASHBACK &&
          <ShellRoute
            path='/cashback-black'
            component={LandingCashbackBlack}
          />
        }

        {process.env.REACT_APP_LADDING_CASHBACK &&
          <ShellRoute
            path='/cashback-dms'
            component={LandingCashbackDms}
          />
        }

        <Route path='/redirect' component={RedirectCustom} />

        <Route path='/purchase-points'>
          <Redirect to='/auth/logout' />
        </Route>
        <Route path='/guest'>
          <Redirect to='/' />
        </Route>

        {yn(process.env.REACT_APP_HAS_OFFERS_CLUB) ? (
          <ShellRoute path='/offers-club' component={OffersListing} />
        ) : (
          ''
        )}
        {yn(process.env.REACT_APP_HAS_STIX) ? (
          <ShellRoute path='/stix' component={StixContainer} />
        ) : (
          ''
        )}
        <ShellRoute component={FourOFour} isGuest />
      </Switch>
    )}
  </Fragment>
)

export default AppRouter



// WEBPACK FOOTER //
// ./src/App/AppRouter.js